// extracted by mini-css-extract-plugin
module.exports = {"root":"IconChat_root__aS5cO"};